import { LabClient } from "@app/api2/api";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "../Contexts/UserContext";
import React from "react";

interface UseUserLabsOptions {
    defaultId?: any;
}

export function useUserLabs({
    defaultId,
}: UseUserLabsOptions) {
    const labClient = new LabClient();
    const user = useUser();

    // console.log(`useUserLabs: defaultId=${defaultId}, userLabId=${user?.user?.lab?.id}`);

    // if (!user?.user) return <div>Loading...</div>;

    const query = useQuery({
        queryKey: ['labs'],
        queryFn: () => labClient.getAll().then(response => response.labs.map(lab => ({ value: lab.id, text: lab.name }))),
    })

    const [selectedLabId, setSelectedLabId] = React.useState(defaultId || user?.user?.lab?.id || query.data?.[0]?.value || null);

    return {
        singleLab: user?.user?.hasSingleLab ?? true,
        labs: query.data,
        selectedLabId,
        getDropdownProps: (props) => ({
            ...props,
            options: query.data ?? [],
            value: selectedLabId,
            onChange: (e, { value }) => setSelectedLabId(value),
        }),
    };
}





